import produce, { enableES5 } from "immer";
enableES5();
import { IReceivedMessageModel } from "src/Core/ViewModels/Message/ReceivedMessageModel";
/* eslint-disable */
/**
 * * To handle message selection in common place
 * @param state array of selected message iDs
 * @param action select or unselect messages
 * @returns state and dispatch action method
 */
export const receivedMessageReducer = produce(
    (draft: { messages: IReceivedMessageModel[]; isAllSelected: boolean }, action: any) => {
        switch (action.type) {
            case "add":
                const newMessages = [action.payload, ...(action.payload.threadMessages ?? [])];
                newMessages.forEach(msg => {
                    if (!draft.messages.some(existing => `${existing.receivedMessageId}_${existing.folderId}` === `${msg.receivedMessageId}_${msg.folderId}`)) {
                        draft.messages.push(msg);
                    }
                });
                draft.isAllSelected = action.messageCount === draft.messages.length;
                break;
            case "remove":
                const index = draft.messages.findIndex(
                    item => `${item.receivedMessageId}_${item.folderId}` === `${action.payload.receivedMessageId}_${action.payload.folderId}`
                );
                if (index > -1) {
                    draft.messages.splice(index, 1);
                    draft.isAllSelected = false;
                }
                break;
                case "addAll":
                    draft.messages = action.payload.flatMap((message: IReceivedMessageModel): IReceivedMessageModel[] => [
                        message,
                        ...(message.threadMessages ?? []),
                    ]);
                    draft.isAllSelected = true;
                    break;
            case "removeAll":
                draft.messages = [];
                draft.isAllSelected = false;
                break;
        }
        return draft;
    }
);
